import React from'react';
import HeroSection from'./HeroSection';
import ProblemSection from'./ProblemSection';
import SolutionSection from'./SolutionSection';
import UseCasesSection from'./UseCasesSection';
import ProcessSection from'./ProcessSection';
import CostComparisonSection from'./CostComparisonSection';
import FAQSection from'./FAQSection';
import CTASection from'./CTASection';
import Footer from'../components/common/Footer';

interface HomePageProps {}

const HomePage = ({}: HomePageProps) => {
  return (
    <div className="w-full bg-white">
      <main className="w-full flex flex-col items-center">
        <HeroSection />
        <ProblemSection />
        {/* SolutionSection hidden per request */}
        <UseCasesSection />
        <ProcessSection />
        <CostComparisonSection />
        <FAQSection />
        {/* CTASection removed */}
        
        {/* Footer Section with Vertical Lines */}
        <div className="w-full max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-end w-full pt-8 sm:pt-12 lg:pt-16">
            <div className="hidden lg:block w-px h-64 sm:h-72 lg:h-80 xl:h-[350px] bg-gradient-to-b from-transparent via-[#FF3333] to-transparent opacity-50"></div>
            <div className="flex-1 w-full">
              <Footer />
            </div>
            <div className="hidden lg:block w-px h-64 sm:h-72 lg:h-80 xl:h-[350px] bg-gradient-to-b from-transparent via-[#FF3333] to-transparent opacity-50"></div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default HomePage
